import React, { useState } from "react";

import Header from "./Header";
import Body from "./Body";

function Table(props) {
  const [sortByDate, setSortByDate] = useState(true);

  function toggleActivitiesListByDate(sortBy) {
    setSortByDate(prevState => !prevState);
  }

  return (
    <div className="web_logs_table web_logs_empty">
      <Header
        dates={props.dates}
        enterDates={props.enterDates}
        showScrollTop={props.showScrollTop}
        sortByDate={sortByDate}
        toggleActivitiesListByDate={toggleActivitiesListByDate}
      />

      <Body sortByDate={sortByDate} />
    </div>
  );
}

export default Table;
